import React from "react";
import { Control, Controller } from "react-hook-form";

import NoticeStageSelect from "components/form_components/NoticeStageSelect";
import { NoticesStagesv2 } from "lib/types/graphQLEnums";
import { NoticeFilters } from "../utils";

import css from "./SharedFilterGroups.module.scss";

export interface ProcurementStageFilterContentProps {
  control: Control<NoticeFilters, unknown>;
}

function ProcurementStageFilterContent({ control }: ProcurementStageFilterContentProps) {
  return (
    <div aria-label="Procurement stage filters">
      <Controller
        name="stage"
        control={control}
        render={({ field }) => (
          <div className={css.filterSection}>
            <NoticeStageSelect {...field} checkedStages={field.value as NoticesStagesv2[]} />
          </div>
        )}
      />
    </div>
  );
}

export default ProcurementStageFilterContent;
